
'use strict';


/**
 * @type Controller
 * @name RevisionDialogCtrl
 * @packageName revision_dialog_ctrl.js
 *
 * @description
 *
 * The `RevisionDialogCtrl` interaction delete mdDialog for revisons
 *
 */
class RevisionDialogCtrl {


    constructor( $scope, $mdDialog, revisions ) {

    	//Attach dependicies to class root
    	this.$mdDialog = $mdDialog;

        //Load revisions in view
        $scope.revisions = revisions;
        
    	//Clicked on the CANCEL button!
    	$scope.hideDailog = () => {

    		this.cancelButton();
    	};

		//Selected an revision
    	$scope.applyRevision = ( $revision )  => {

    		this.applyRevision( $revision );
    	};
    }


    /*
     * return selected revision back to form
     */ 
    applyRevision ( $revision ) {
        this.$mdDialog.hide( $revision.value );
    }


	/*
     * managed CANCEL event from confirm dailog
     */	
    cancelButton () {

        this.$mdDialog.cancel();
    }
}


/*
 * Inject dependicies
 */
RevisionDialogCtrl.$inject = ['$scope', '$mdDialog', 'revisions'];


/*
 * Browsify connection: execute controller
 */
module.exports = RevisionDialogCtrl;
